import React, { useState, useEffect } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./UploadProgressPopup.scss";
import images from "../../../assets/images";

interface UploadToasterType {
  uploaded: boolean;
  setuploaded: (val: boolean) => void;
  uploadProgress: number;
  fileName: string|undefined;
  setUploadFileName: any;
  uploadFailed:boolean;
  setUploadFailed:any;
  setUploadProgress:any;
}

const UploadToaster: React.FC<UploadToasterType> = ({uploaded, setuploaded, uploadProgress, setUploadProgress, fileName, setUploadFileName, uploadFailed, setUploadFailed}) => {
  const [expanded, setExpanded] = useState(true);
  const { Check, UploadIcon, UploadFailedSvg } = images;

  // expand upload progress bar
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

   // Automatically close the popup after a certain time when upload is complete
   useEffect(() => {
    if (uploadProgress === 100 || uploadFailed === true) {
      const timer = setTimeout(() => {
        setuploaded(false);
        setUploadFailed(false);
        setUploadFileName('');
        setUploadProgress(0);
      }, 5000);

      return () => clearTimeout(timer); // Clear the timer if the component is unmounted
    }
  }, [uploadProgress,setuploaded,uploadFailed]);
  
  return (
    <>
      {uploaded && <div className="UploadedContainer">
        <div className="header" onClick={handleExpandClick}>
          <span className={uploadFailed === true ? 'failed' :uploadProgress === 100 ? 'success': ''}>{uploadFailed === true ? 'Upload Failed' : uploadProgress === 100 ? 'Uploaded Successfully' : 'Uploading'}</span>
          <div className={ expanded ? "rotate_down" : "rotate_up" }>
            <ExpandMoreIcon />
          </div>
        </div>

        {expanded && (
          <div className="card">
            <div className="card-content">
              {uploadFailed === true ? (
                <div className="CheckIcon">
                <img src={UploadFailedSvg} alt="failIcon"/>
              </div>
              ) : uploadProgress === 100 ? (
                <div className="CheckIcon">
                  <img src={Check} alt="tick Icon"/>
                </div>
              ) : (
                <div className="spinnerContainer">
                  <div className="spinner" />
                  <img src={UploadIcon} alt="uploadIcon" className="UploadIcon" />
                </div>
              )}
              <div className="file-details">
                <div>{fileName ? fileName : ''}</div>
                {uploadFailed === true ? (
                  <div style={{ fontSize: "12px", color: "#757575" }}>
                    Failed
                  </div>
                ):(
                  <div style={{ fontSize: "12px", color: "#757575" }}>
                    {uploadProgress}%
                  </div>
                )}
                <div className="progress-bar-container">
                  <div
                    className="progress-bar"
                    style={{ width: `${uploadProgress}%` }}
                  ></div>
                </div>
              </div>
            </div>
            <button className="doneBtn" disabled={!(uploadProgress === 100 || uploadFailed === true)} onClick={() => {setuploaded(false);setUploadFileName('');setUploadFailed(false); setUploadProgress(0);}}>
              <label className="button">Done</label>
            </button>
          </div>
        )}
      </div>}
    </>
  );
};

export default UploadToaster;
